import { EpicRefined } from 'interfaces/middleware'
import { AdvisorsPatchReviewAction, AdvisorMeetingActions } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { mergeMap, map } from 'rxjs/operators'
import { PATCH_REVIEW_URL } from 'interfaces/ajax'
import { of } from 'rxjs'
import { getTokenHeader } from 'components/features/coaching/advisorVideoCall/helpers'
import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'

export const patchReviewEpic: EpicRefined<AdvisorMeetingActions | AjaxCatchExtraActions> = (action$, _, { post }) => action$.pipe(
  filterRequestOfType(AdvisorsPatchReviewAction.type, 'request'),
  mergeMap((action) => {
    const { params } = action.payload
    return post(PATCH_REVIEW_URL, { body: params }, getTokenHeader()).pipe(
      map(({ response }) => action.success(response)),
      ajaxCatch((error) => of(action.fail({ errorCode: error.status }))),
    )
  }),
)
